console.log('window.location', window.location);

import $ from 'jquery';
import algoliasearch from 'algoliasearch';
import instantsearch from 'instantsearch.js';
import aa from 'search-insights';
import {
  configure,
  hits,
  pagination,
  searchBox,
  sortBy,
  refinementList,
  toggleRefinement
} from 'instantsearch.js/es/widgets';
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares';
import {
  scrollToElement,
  getQueryParamsAsObject,
  decodeHtml
} from './lib/utilities';
import { AJAX_URL } from './config';
import { use } from 'react';

const formContainer = '#algolia-search-box';
const hitsContainer = '#algolia-hits';
const categoriesContainer = '#algolia-categories';
const sortbyContainer = '#algolia-sortby';
const paginationContainer = '#algolia-pagination';
const queryParams = getQueryParamsAsObject();
const appId = wlAlgolia.application_id;
const apiKey = wlAlgolia.search_api_key;
const indexName = wlProductIndex.indexName;
const insightsMiddleware = createInsightsMiddleware({
  insightsClient: aa
});
let userLoggedIn = wlProductIndex.userLoggedIn;
let userRoles = wlProductIndex.userRoles;

const filterHitsByUserRole = (item, userLoggedIn, userRoles = []) => {
  userRoles = Array.isArray(userRoles)
    ? userRoles
    : [userRoles].filter(Boolean);
  const restrictedRoles = item.restricted || [];

  if (userRoles.includes('administrator')) {
    return true;
  }

  if (restrictedRoles.length) {
    if (!userLoggedIn) return false;
    return userRoles.some((role) => restrictedRoles.includes(role));
  }

  return true;
};

if ((queryParams || {}).q) setTimeout(scrollToTop, 500);

console.log('queryParams', queryParams);

if ($(formContainer).length > 0) {
  // Instantiate instantsearch.js
  const search = instantsearch({
    searchClient: algoliasearch(appId, apiKey),
    indexName,
    routing: {
      stateMapping: {
        stateToRoute(uiState) {
          const indexUiState = uiState[indexName];
          return {
            q: indexUiState.query,
            pagination: indexUiState.page,
            grade_level:
              indexUiState.refinementList &&
              indexUiState.refinementList.grade_level,
            product_type:
              indexUiState.refinementList &&
              indexUiState.refinementList.product_type,
            product_cat:
              indexUiState.refinementList &&
              indexUiState.refinementList.product_cat
          };
        },
        routeToState(routeState) {
          return {
            [indexName]: {
              query: routeState.q,
              refinementList: {
                grade_level: routeState.grade_level,
                product_type: routeState.product_type,
                product_cat: routeState.product_cat
              },
              page: routeState.pagination
            }
          };
        }
      }
    }
  });
  search.use(insightsMiddleware);

  const widgetConfig = configure({
    hitsPerPage: 24,
    facetingAfterDistinct: true,
    highlightPreTag: '__ais-highlight__',
    highlightPostTag: '__/ais-highlight__',
    disjunctiveFacets: ['grade_level', 'product_type', 'product_cat']
  });

  const widgetSearchBox = searchBox({
    container: formContainer,
    placeholder: 'Search by Keyword...',
    queryHook: (query, search) => search(query),
    poweredBy: false,
    searchAsYouType: true,
    reset: false,
    showSubmit: false,
    searchOnEnterKeyPressOnly: true,
    wrapInput: true,
    cssClasses: {
      submit: ['btn btn--primary'],
      input: ['site-search']
    },
    templates: {
      submit: `Search`
    }
  });

  const widgetHits = hits({
    escapeHTML: false,
    container: hitsContainer,
    templates: {
      empty: 'No results were found for "<strong>{{query}}</strong>".',
      item: window.wp.template('product-hit')
    },
    transformItems: (items) => {
      return items
        .filter((item) => filterHitsByUserRole(item, userLoggedIn, userRoles))
        .map((item) => {
          item.__isDownloadable = false;
          item.__canAddToCart = false;

          if (item.product_type.includes('Download')) {
            item.__isDownloadable = true;
          }

          if (
            item.product_type.includes('Mail Order') ||
            item.product_type.includes('Email Order')
          ) {
            item.__canAddToCart = true;
          }

          return item;
        });
    }
  });

  const widgetPagination = pagination({
    container: paginationContainer,
    templates: {
      next: '<i class="icon-caret-double-right"></i>',
      previous: '<i class="icon-caret-double-left"></i>'
    },
    maxPages: 8,
    showFirst: false,
    showLast: false,
    scrollTo: false,
    cssClasses: {
      noRefinementRoot: 'u--display-none'
    }
  });

  const widgetRefinementListCategories = refinementList({
    container: '#algolia-refinement-list-categories',
    attribute: 'product_cat',
    cssClasses: {
      root: 'algolia-refinement-list',
      list: ['select-dropdown__list']
    },
    sortBy: ['name:asc'],
    limit: 20,
    templates: {
      item: `
        <label class="select-dropdown__checkbox-container">
          {{label}} <input type="checkbox"{{#isRefined}} checked{{/isRefined}}>
          <span class="select-dropdown__checkmark"></span>
        </label>
      `
    },
    transformItems: (items) => {
      let newItems = items.filter((item) => {
        item.label = decodeHtml(item.label);
        if (item.label === 'TBC Staff') {
          item.restricted = ['tbc_staff'];
        } else {
          item.restricted = [];
        }
        let allow = filterHitsByUserRole(item, userLoggedIn, userRoles);

        if (allow) {
          return item;
        }
      });

      return newItems;
    }
  });

  const widgetRefinementListGrades = refinementList({
    container: '#algolia-refinement-list-grades',
    attribute: 'grade_level',
    cssClasses: {
      root: 'algolia-refinement-list',
      list: ['select-dropdown__list']
    },
    templates: {
      item: `
        <label class="select-dropdown__checkbox-container">
          {{label}} <input type="checkbox"{{#isRefined}} checked{{/isRefined}}>
          <span class="select-dropdown__checkmark"></span>
        </label>
      `
    }
  });

  const widgetRefinementListTypes = refinementList({
    container: '#algolia-refinement-list-types',
    attribute: 'product_type',
    cssClasses: {
      root: 'algolia-refinement-list',
      list: ['select-dropdown__list']
    },
    sortBy: ['name:asc'],
    templates: {
      item: `
        <label class="select-dropdown__checkbox-container">
          {{label}} <input type="checkbox"{{#isRefined}} checked{{/isRefined}}>
          <span class="select-dropdown__checkmark"></span>
        </label>
      `
    }
  });

  let userToken = '';

  search.addWidgets([
    widgetConfig,
    widgetSearchBox,
    widgetRefinementListCategories,
    widgetRefinementListGrades,
    widgetRefinementListTypes,
    widgetHits,
    widgetPagination
  ]);

  // Start search
  search.start();

  // Get search queryID, needed for analytics payload.
  const getQueryID = () => search.helper.lastResults.queryID;

  // Focus input
  $(formContainer).find('input').attr('type', 'search').select();

  // Init Algolia analytics
  aa('init', { appId, apiKey });
  aa('getUserToken', null, (err, algoliaUserToken) => {
    if (err) return;
    userToken = algoliaUserToken;
  });

  // Add event listeners to scroll to search content
  $('html').on('submit', formContainer, scrollToTop);
  $('html').on('click', `${paginationContainer} a`, scrollToTop);
  $('html').on('change', `${categoriesContainer}`, scrollToTop);
  $('html').on('click', `${hitsContainer} a.search-hit`, (event) => {
    aa('clickedObjectIDsAfterSearch', {
      userToken,
      eventName: 'Hit Clicked',
      index: indexName,
      objectIDs: [event.currentTarget.getAttribute('data-object-id')],
      positions: [
        parseInt(event.currentTarget.getAttribute('data-object-position'))
      ],
      queryID: getQueryID()
    });
  });
}

// function pageInHistory() {
//   history.replaceState({}, '', window.location.href);
//   console.log('history', history);
// }
function scrollToTop(event) {
  if (event) event.preventDefault();
  scrollToElement(categoriesContainer);
}
